import React from 'react';
import { ClipboardIcon, PhoneIcon, PaletteIcon, TruckIcon } from 'lucide-react';
export const ProcessSection = () => {
  const steps = [{
    icon: <ClipboardIcon className="w-12 h-12 text-[#234837]" data-id="element-116" />,
    title: 'Je aanvraag doen',
    description: "Vul het formulier in, geen foto's nodig"
  }, {
    icon: <PhoneIcon className="w-12 h-12 text-[#234837]" data-id="element-117" />,
    title: 'We nemen contact op',
    description: 'Binnen 1 werkdag hoor je van ons'
  }, {
    icon: <PaletteIcon className="w-12 h-12 text-[#234837]" data-id="element-118" />,
    title: 'Keuze van materiaal',
    description: 'Samen kiezen we de beste materialen en planning'
  }, {
    icon: <TruckIcon className="w-12 h-12 text-[#234837]" data-id="element-119" />,
    title: 'Stofferen & afleveren',
    description: 'Vakkundig stofferen en op tijd leveren'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-120">
      <div className="container mx-auto px-4" data-id="element-121">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-122">
          Zo werkt het
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-123">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-sm" data-id="element-124">
              <div className="mb-4" data-id="element-125">{step.icon}</div>
              <h3 className="text-xl font-bold mb-2" data-id="element-126">{step.title}</h3>
              <p className="text-gray-600" data-id="element-127">{step.description}</p>
              {index < steps.length - 1 && <div className="hidden lg:block absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2" data-id="element-128">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-gray-400" data-id="element-129">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-130" />
                  </svg>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};